<template>
  <div id="artists" class="artists">
    <chief-whip />
    <soulcraft />
    <testimonials />
  </div>
</template>



<script>
// @ is an alias to /src
import ChiefWhip from '@/components/ChiefWhip.vue'
import Soulcraft from '@/components/Soulcraft.vue'
import Testimonials from '@/components/Testimonials.vue'
export default {
  name: 'Artists', 
  components: {
    ChiefWhip,
    Soulcraft,
    Testimonials
  },
  activated(){
    this.showMenu = false;
  }
}
</script>
